import moment from "moment-timezone";

export function secondsToHMS(seconds: number) {
  let hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  let minutes = Math.floor(seconds / 60);
  seconds %= 60;

  return [hours, minutes, Math.floor(seconds)]
    .map((v) => v.toString().padStart(2, "0"))
    .join(":");
}

export const formatDateToTimezone = (
  date: string,
  timezone: string,
  formatDate: string
): string => {
  // const dateYYYYMMDD = date.split("T")[0];
  return moment(date).utc().tz(timezone).format(formatDate);
};

export const timeToSeconds = (time: string) => {
  const parts = time.split(":");
  const hours = parseInt(parts[0], 10) || 0;
  const minutes = parseInt(parts[1], 10) || 0;
  const seconds = parseInt(parts[2], 10) || 0;

  return hours * 3600 + minutes * 60 + seconds;
};

export const isValidTimeFormat = (time: string) => {
  const regex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
  return regex.test(time);
};

export const formatSecondsToMinutes = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");
  return `${formattedMinutes}:${formattedSeconds}`;
};
